module.exports = __webpack_public_path__ + "img/accessory_pants_07.584d5731.svg";